import { useCallback, useState } from 'react';

const DATA_ZONE_STORAGE_OPTIONS = [
  { label: '일별 신규 적재', value: 'daily' },
  { label: '전체 누적', value: 'total' },
];

const DATA_ZONE_STORAGE_TYPE_OPTIONS = [
  { label: '전체', value: 'all' },
  { label: 'Gold', value: 'gold' },
  { label: 'Silver', value: 'silver' },
  { label: 'Bronze', value: 'bronze' },
];

export const useDataZoneStorageSelect = () => {
  const [selectedDataZoneStorageValue, setSelectedDataZoneStorageValue] = useState<string>('daily');
  const [selectedDataZoneStorageTypeValue, setSelectedDataZoneStorageTypeValue] = useState<string>('all');

  const handleSelectDataZoneStorageValue = useCallback((value: string) => {
    setSelectedDataZoneStorageValue(value);
  }, []);

  const handleSelectDataZoneStorageTypeValue = useCallback((value: string) => {
    setSelectedDataZoneStorageTypeValue(value);
  }, []);

  return {
    DATA_ZONE_STORAGE_OPTIONS,
    DATA_ZONE_STORAGE_TYPE_OPTIONS,
    selectedDataZoneStorageValue,
    selectedDataZoneStorageTypeValue,
    handleSelectDataZoneStorageValue,
    handleSelectDataZoneStorageTypeValue,
  };
};
